import axios from '../axios'; // ✅ تأكد من وجود ملف إعداد axios

// 🧪 دالة اختبار الاتصال
export async function testConnection() {
  try {
    const response = await axios.get('/api/test-connection');
    return { success: true, message: response.data.message };
  } catch (error) {
    console.error("❌ فشل الاتصال بالسيرفر:", error);
    return { success: false, message: '❌ فشل الاتصال بالسيرفر' };
  }
}

// 📦 جلب كل الفئات
export async function fetchCategories() {
  try {
    const response = await axios.get('/api/categories');
    return response.data;
  } catch (error) {
    console.error("❌ فشل في جلب الفئات:", error);
    return [];
  }
}

// 🍔 جلب كل المنتجات
export async function fetchProducts() {
  try {
    const response = await axios.get('/api/products');
    return response.data;
  } catch (error) {
    console.error("❌ فشل في جلب المنتجات:", error);
    return [];
  }
}

// 🧮 جلب المنتجات حسب فئة
export async function fetchProductsByCategory(categoryId) {
  try {
    const response = await axios.get(`/api/categories/${categoryId}/products`);
    return response.data;
  } catch (error) {
    console.error(`❌ فشل في جلب منتجات الفئة ${categoryId}:`, error);
    return [];
  }
}

// 🍽️ جلب تفاصيل منتج مع الأقسام والخيارات
export async function fetchProductDetails(productId) {
  try {
    const response = await axios.get(`/api/products/${productId}`);
    return response.data;
  } catch (error) {
    console.error(`❌ فشل في جلب تفاصيل المنتج ${productId}:`, error);
    return null;
  }
}

// 🚚 جلب مناطق التوصيل
export async function fetchDeliveryZones() {
  try {
    const response = await axios.get('/api/delivery-zones');
    return response.data.zones.map(zone => ({
      ...zone,
      delivery_fee: Number(zone.delivery_fee), // تأكيد أنه رقم
    }));
  } catch (error) {
    console.error("❌ فشل في جلب مناطق التوصيل:", error);
    return [];
  }
}

// 🧾 إرسال الطلب إلى السيرفر
export async function submitOrder(orderData) {
  try {
    const response = await axios.post('/api/orders', orderData);
    return response.data;
  } catch (error) {
    console.error('❌ فشل إرسال الطلب:', error.response?.data || error.message);
    throw error;
  }

  
}

export async function adminLogin(credentials) {
  try {
    const response = await axios.post('/api/admin/login', credentials);
    return response.data;
  } catch (error) {
    console.error('❌ فشل تسجيل الدخول:', error.response?.data || error.message);
    throw error;
  }
}


// 📋 جلب كل الطلبات (Dashboard)
export async function fetchOrders() {
  try {
    const response = await axios.get('/api/orders');
    return response.data.orders || [];
  } catch (error) {
    console.error("❌ فشل في جلب الطلبات:", error.response?.data || error.message);
    return [];
  }
}

export async function updateOrderStatus(orderId, newStatus) {
  const response = await axios.put(`/api/orders/${orderId}/status`, {
    status: newStatus,
  });
  return response.data;
}

// ➕ إضافة منتج جديد
export async function addProduct(formData) {
  try {
    const response = await axios.post('/api/products', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("❌ فشل في إضافة المنتج:", error.response?.data?.errors || error.response?.data || error.message);
    throw error;
  }
}


// 🧑‍💼 جلب المنتجات الخاصة بالمشرف
export async function fetchAdminProducts() {
  try {
    const response = await axios.get('/api/admin/products');
    return response.data.products || []; // تأكد أن الباك يرجع 'products'
  } catch (error) {
    console.error("❌ فشل في جلب منتجات المشرف:", error.response?.data || error.message);
    return [];
  }
}

export async function fetchProductForEdit(productId) {
  try {
    const response = await axios.get(`/api/admin/products/${productId}`);

    // ✅ إرجاع كامل الاستجابة حتى لو احتجت الرسائل أو الأخطاء لاحقًا
    return response.data;
  } catch (error) {
    console.error(`❌ فشل في جلب المنتج رقم ${productId}:`, error.response?.data || error.message);
    return {
      status: false,
      message: 'فشل في جلب المنتج',
      error: error.response?.data || error.message,
    };
  }
}


// 🗑️ حذف منتج (مع توابعه)
export async function deleteProduct(productId) {
  try {
    const response = await axios.delete(`/api/admin/products/${productId}`);
    return response.data;
  } catch (error) {
    console.error(`❌ فشل في حذف المنتج ${productId}:`, error.response?.data || error.message);
    throw error;
  }
}


// ➕ إضافة فئة جديدة (اسم + صورة)
export async function addCategory(formData) {
  try {
    const response = await axios.post('/api/admin/categories', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("❌ فشل في إضافة الفئة:", error.response?.data || error.message);
    throw error;
  }
}


// ✏️ تعديل فئة
export async function updateCategory(id, formData) {
  try {
    const response = await axios.post(`/api/admin/categories/${id}?_method=PUT`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    console.error(`❌ فشل في تعديل الفئة ${id}:`, error.response?.data || error.message);
    throw error;
  }
}

// 🗑️ حذف فئة
export async function deleteCategory(id) {
  try {
    const response = await axios.delete(`/api/admin/categories/${id}`);
    return response.data;
  } catch (error) {
    console.error(`❌ فشل في حذف الفئة ${id}:`, error.response?.data || error.message);
    throw error;
  }
}


export async function addDeliveryZone(data) {
  try {
    const response = await axios.post('/api/admin/delivery-zones', data);
    return response.data;
  } catch (error) {
    console.error("❌ فشل في إضافة منطقة التوصيل:", error.response?.data || error.message);
    throw error;
  }
}

export async function updateDeliveryZone(id, data) {
  try {
    const response = await axios.put(`/api/admin/delivery-zones/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`❌ فشل في تعديل المنطقة ${id}:`, error.response?.data || error.message);
    throw error;
  }
}

export async function deleteDeliveryZone(id) {
  try {
    const response = await axios.delete(`/api/admin/delivery-zones/${id}`);
    return response.data;
  } catch (error) {
    console.error(`❌ فشل في حذف المنطقة ${id}:`, error.response?.data || error.message);
    throw error;
  }


}


// ✅ جلب طلب واحد حسب ID (للطباعة أو العرض)
export async function fetchOrderById(orderId) {
  try {
    const response = await axios.get(`/api/orders/${orderId}`);
    return response.data.order;
  } catch (error) {
    console.error(`❌ فشل في جلب تفاصيل الطلب ${orderId}:`, error.response?.data || error.message);
    return null;
  }
}


// 📊 جلب جميع التكاليف
export async function fetchCosts() {
  try {
    const response = await axios.get('/api/costs');
    return response.data.costs || [];
  } catch (error) {
    console.error("❌ فشل في جلب التكاليف:", error.response?.data || error.message);
    return [];
  }
}

// ➕ إضافة تكلفة جديدة
export async function addCost(data) {
  try {
    const response = await axios.post('/api/costs', data);
    return response.data;
  } catch (error) {
    console.error("❌ فشل في إضافة التكلفة:", error.response?.data || error.message);
    throw error;
  }
}

// ✏️ تعديل تكلفة
export async function updateCost(id, data) {
  try {
    const response = await axios.put(`/api/costs/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`❌ فشل في تعديل التكلفة ${id}:`, error.response?.data || error.message);
    throw error;
  }
}

// 🗑️ حذف تكلفة
export async function deleteCost(id) {
  try {
    const response = await axios.delete(`/api/costs/${id}`);
    return response.data;
  } catch (error) {
    console.error(`❌ فشل في حذف التكلفة ${id}:`, error.response?.data || error.message);
    throw error;
  }
}
